/**
 * Centralized Theme Configuration
 * Change colors here to update the entire application
 */

const themes = {
  // Green Theme (Current)
  green: {
    name: 'Green Theme',
    colors: {
      // Primary Colors
      primaryDark: '#004d40',
      primary: '#00695c',
      primaryLight: '#00897b',
      
      // Accent Colors
      accent: '#00bfa5',
      accentLight: '#1de9b6',
      accentTeal: '#26a69a',
      
      // Sidebar
      sidebarDark: '#004d40',
      sidebarMedium: '#00695c',
      
      // Semantic Colors
      success: '#10b981',
      successLight: '#d1fae5',
      warning: '#f59e0b',
      warningLight: '#fef3c7',
      error: '#ef4444',
      errorLight: '#fee2e2',
      info: '#00bfa5',
      infoLight: '#b2dfdb',
      
      // Grays
      gray50: '#f8fafc',
      gray100: '#f1f5f9',
      gray200: '#e2e8f0',
      gray300: '#cbd5e1',
      gray400: '#94a3b8',
      gray500: '#64748b',
      gray600: '#475569',
      gray700: '#334155',
      gray800: '#1e293b',
      gray900: '#0f172a',
    }
  },
  
  // Blue Theme (Alternative)
  blue: {
    name: 'Blue Theme',
    colors: {
      primaryDark: '#1e3a8a',
      primary: '#1e40af',
      primaryLight: '#3b82f6',
      
      accent: '#0ea5e9',
      accentLight: '#38bdf8',
      accentTeal: '#06b6d4',
      
      sidebarDark: '#1e3a8a',
      sidebarMedium: '#1e40af',
      
      success: '#10b981',
      successLight: '#d1fae5',
      warning: '#f59e0b',
      warningLight: '#fef3c7',
      error: '#ef4444',
      errorLight: '#fee2e2',
      info: '#3b82f6',
      infoLight: '#dbeafe',
      
      gray50: '#f8fafc',
      gray100: '#f1f5f9',
      gray200: '#e2e8f0',
      gray300: '#cbd5e1',
      gray400: '#94a3b8',
      gray500: '#64748b',
      gray600: '#475569',
      gray700: '#334155',
      gray800: '#1e293b',
      gray900: '#0f172a',
    }
  }
};

// Set active theme (change this to switch themes)
const ACTIVE_THEME = 'green';

export const currentTheme = themes[ACTIVE_THEME];

/**
 * Apply theme to CSS custom properties
 */
export function applyTheme(themeName = ACTIVE_THEME) {
  const theme = themes[themeName];
  if (!theme) {
    console.error(`Theme '${themeName}' not found`);
    return;
  }
  
  const root = document.documentElement;
  
  // Apply colors
  Object.entries(theme.colors).forEach(([key, value]) => {
    // Convert camelCase to kebab-case
    const cssVar = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    root.style.setProperty(`--${cssVar}`, value);
  });
  
  // Store theme preference
  localStorage.setItem('theme', themeName);
}

/**
 * Get available themes
 */
export function getAvailableThemes() {
  return Object.keys(themes).map(key => ({
    key,
    name: themes[key].name
  }));
}

/**
 * Get saved theme preference
 */
export function getSavedTheme() {
  return localStorage.getItem('theme') || ACTIVE_THEME;
}

export default currentTheme;